import React, { Component } from 'react';
import { Form, Row, Col, Input, Button, Select } from 'antd';
import { Icon, Breadcrumb, Tabs, TreeSelect, message } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { apis } from '../api/index.js';
import 'moment/locale/zh-cn';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import './knowledge.css';
import { makeWb, makePy } from './spell.js';
import Delete from './Delete.js';
import { breadBack, changeListWidth, breadItem } from '../utils';
import KnowledgeTree from './KnowledgeTree.js';
import 'element-theme-default';
import { eventListener } from '../utils';
const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;
const [productionId, pageId] = ['101', '10023'];
class KnowledgeForm extends Component {
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    history: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const userInfo = window.store.getState().api.user.info;
    const role = userInfo.operationAuths.split(',');
    this.state = {
      role,
      listWidth: 'calc(87% - 8px)',
      upperDataList: [],
      treeData: [],
      showDeleteModal: false,
      detail: {},
      currentSelected: {},
      newButtonDisabled: false,
      editButtonDisabled: true,
      deleteButtonDisabled: true,
      editType: '',
      saveType: '',
      privateFlag: role.indexOf('R') >= 0 ? false : true,
      updateTreeData: false,
    };
  }

  componentDidMount() {}

  handleChangeTabs = key => {
    this.setState({
      privateFlag: key === 'public' ? false : true,
      newButtonDisabled: false,
      editButtonDisabled: true,
      deleteButtonDisabled: true,
      detail: {},
      updateTreeData: !this.state.updateTreeData,
    });
    this.props.form.resetFields();
  };

  handleChangeName = ({ target: { value } }) => {
    value = value.trim();
    const { detail } = this.state;
    detail.namepy = value ? makePy(value) : '';
    detail.namewb = value ? makeWb(value) : '';
    this.setState({ detail });
    this.props.form.setFieldsValue({
      pinyin: detail.namepy,
      wubi: detail.namewb,
    });
  };

  setFormValues = (name, upper, sort, pinyin, wubi, finding, impression) => {
    this.props.form.setFieldsValue({
      name,
      upper,
      sort,
      pinyin,
      wubi,
      finding,
      impression,
    });
  };
  hideDeleteModal = changed => {
    if (changed) {
      this.setState({
        deleteButtonDisabled: true,
        editButtonDisabled: true,
        newButtonDisabled: false,
        detail: {},
        currentSelected: {},
        updateTreeData: !this.state.updateTreeData,
      });
      this.setFormValues('', '', '', '', '', '', '');
    }
    this.setState({ showDeleteModal: false });
  };

  handleDeleteTree = () => {
    const { privateFlag } = this.state;
    this.setState({ showDeleteModal: true });

    let [moduleId, elementId] = ['', ''];
    if (privateFlag === 'public') [moduleId, elementId] = ['mk0001', 'ns-009'];
    else [moduleId, elementId] = ['mk0002', 'ns-005'];
    const eventData = { productionId, pageId, moduleId };
    eventListener({ ...eventData, elementId });
  };

  newFloder = () => {
    const eventData = { productionId, pageId, moduleId: 'mk0002' };
    eventListener({ ...eventData, elementId: 'ns-001' });

    const { currentSelected } = this.state;
    const children = currentSelected.child || [];
    const upper = currentSelected.id || 0;
    const len = children.length;
    this.setState({
      editType: 'floder',
      saveType: 'new',
      detail: { upper: upper, orderNum: len },
    });
    this.setFormValues('', upper, len, '', '', '', '');
  };

  newFile = () => {
    const eventData = { productionId, pageId, moduleId: 'mk0002' };
    eventListener({ ...eventData, elementId: 'ns-002' });

    const { currentSelected } = this.state;
    const children = currentSelected.child || [];
    const upper = currentSelected.id || 0;
    const len = children.length;
    this.setState({
      editType: 'file',
      saveType: 'new',
      detail: { upper: upper, orderNum: len },
    });
    this.setFormValues('', upper, len, '', '', '', '');
  };

  edit = () => {
    const { detail, privateFlag } = this.state;
    let editType = 'file';
    if (detail.fileFlag) editType = 'floder';
    this.setState({ editType, saveType: 'edit' });

    let [moduleId, elementId] = ['', ''];
    if (privateFlag === 'public') [moduleId, elementId] = ['mk0001', 'ns-008'];
    else [moduleId, elementId] = ['mk0002', 'ns-004'];
    const eventData = { productionId, pageId, moduleId };
    eventListener({ ...eventData, elementId });
  };

  onSave = e => {
    const { privateFlag } = this.state;
    let [moduleId, elementId] = ['', ''];
    if (privateFlag === 'public') [moduleId, elementId] = ['mk0001', 'ns-014'];
    else [moduleId, elementId] = ['mk0002', 'ns-010'];
    const eventData = { productionId, pageId, moduleId, elementId };
    eventListener(eventData);

    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { editType, privateFlag, saveType, currentSelected } = this.state;
        const post = {
          name: values.name, //名称
          upper: values.upper, // 上级id，必填。如果是一级目录是0
          orderNum: values.sort, // 排序号
          type: values.type, // 仪器类型 字典大类：modality
          namepy: values.pinyin, // 拼音简码
          namewb: values.wubi, //五笔简码
          institutionId: -1, // 机构、九峰医疗为-1
          fileFlag: editType === 'file' ? false : true, // 是否是文件
          privateFlag: privateFlag, //是否是个人知识库
          remark: null,
          finding: values.finding, //影像所见
          impression: values.impression, //诊断建议
        };
        let url, successMsg;
        if (saveType === 'edit') {
          post.id = currentSelected.id;
          successMsg = '修改成功';
          url = apis.updateKnowledge(post);
        } else if (saveType === 'new') {
          successMsg = '添加成功';
          url = apis.saveKnowledge(post);
        }
        url.then(res => {
          if (res.code === '0') {
            message.success(successMsg);
            this.setState({ updateTreeData: !this.state.updateTreeData });
          } else if (res.code === '1009') {
            message.error('请先登录');
            this.props.history.push('/login');
          }
        });
      }
    });
  };

  setUpperDataList = data => {
    let treeDataString = JSON.stringify(data);
    treeDataString = treeDataString.replace(/name/g, 'title');
    treeDataString = treeDataString.replace(/id/g, 'value');
    treeDataString = treeDataString.replace(/child/g, 'children');
    this.setState({ upperDataList: JSON.parse(treeDataString) });
  };

  setFileFlag = (data, currentSelected) => {
    let newButtonDisabled = true;
    if (data.fileFlag) newButtonDisabled = false;

    this.setState({
      newButtonDisabled,
      editButtonDisabled: false,
      deleteButtonDisabled: false,
      editType: '',
      detail: data,
      currentSelected,
    });
  };
  setBackEvent = () => {
    const { privateFlag } = this.state;
    let [moduleId, elementId] = ['', ''];
    if (privateFlag === 'public') [moduleId, elementId] = ['mk0001', 'ns-015'];
    else [moduleId, elementId] = ['mk0002', 'ns-011'];

    const eventData = { productionId, pageId, moduleId, elementId };
    eventListener(eventData);
  };

  findingBlurEvent = e => {
    const { privateFlag } = this.state;
    const prms = e.target.value;
    let [moduleId, elementId] = ['', ''];
    if (privateFlag === 'public') [moduleId, elementId] = ['mk0001', 'ns-010'];
    else [moduleId, elementId] = ['mk0002', 'ns-006'];

    const eventData = { productionId, pageId, moduleId, elementId, prms };
    eventListener({ ...eventData });
  };
  impressionBlurEvent = e => {
    const { privateFlag } = this.state;
    let [moduleId, elementId] = ['', ''];
    if (privateFlag === 'public') [moduleId, elementId] = ['mk0001', 'ns-011'];
    else [moduleId, elementId] = ['mk0002', 'ns-007'];
    const prms = e.target.value;
    const eventData = { productionId, pageId, moduleId, elementId, prms };
    eventListener({ ...eventData });
  };
  render() {
    const { role, detail, upperDataList, editType } = this.state;
    const { privateFlag } = this.state;

    const leftHeight = window.screen.height - 320;
    const { getFieldDecorator } = this.props.form;
    const hasPublic = role.includes('R');
    const inputDisabled = ['file', 'floder'].includes(editType) ? false : true;
    const areaDisabled = editType === 'file' ? false : true;

    const formCol = { labelCol: { span: 6 }, wrapperCol: { span: 16 } };
    const formCol1 = { labelCol: { span: 24 }, wrapperCol: { span: 24 } };

    return (
      <div className="form-bg">
        <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={() => changeListWidth(this)}
            login={false}
            home={true}
          />
          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>
                {breadItem(['远程诊断报告', '知识库管理'])}
              </Breadcrumb>
              {breadBack(this)}
            </div>
            <div className="box" style={{ width: this.state.listWidth }}>
              <div className="knowledge-content">
                <div className="box-left">
                  <Tabs
                    defaultActiveKey={hasPublic ? 'public' : 'private'}
                    onChange={this.handleChangeTabs}
                  >
                    {hasPublic && <TabPane tab="公共知识库" key="public" />}

                    <TabPane tab="个人知识库" key="private" />
                  </Tabs>
                  <div
                    className="knowledge-left"
                    style={{ height: leftHeight }}
                  >
                    {!privateFlag && (
                      <Form
                        className="ant-advanced-search-form"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                      >
                        <Form.Item label="所属中心" colon={false}>
                          {getFieldDecorator('chestStatus', {
                            initialValue: 'JF16373',
                          })(
                            <Select disabled={true}>
                              <Option value="JF16373">JF16373</Option>
                            </Select>
                          )}
                        </Form.Item>
                        <Form.Item label="仪器类型" colon={false}>
                          {getFieldDecorator('type', {
                            initialValue: 'DR',
                          })(
                            <Select disabled={true}>
                              <Option value="DR">DR</Option>
                            </Select>
                          )}
                        </Form.Item>
                      </Form>
                    )}
                    <div>
                      <Button
                        size="small"
                        disabled={this.state.newButtonDisabled}
                        onClick={this.newFloder}
                      >
                        <Icon type="folder-add" theme="filled" />
                        新建文件夹
                      </Button>
                      <Button
                        size="small"
                        disabled={this.state.newButtonDisabled}
                        onClick={this.newFile}
                      >
                        <Icon type="file-add" theme="filled" />
                        新建文件
                      </Button>
                      <Button
                        size="small"
                        disabled={this.state.editButtonDisabled}
                        onClick={this.edit}
                      >
                        <Icon type="edit" theme="filled" />
                        修改
                      </Button>
                      <Button
                        size="small"
                        onClick={this.handleDeleteTree}
                        disabled={this.state.deleteButtonDisabled}
                      >
                        <Icon type="delete" theme="filled" />
                        删除
                      </Button>
                    </div>
                    <div className="title">目录</div>
                    <KnowledgeTree
                      privateFlag={privateFlag}
                      form={this.props.form}
                      setUpperDataList={this.setUpperDataList}
                      setFileFlag={this.setFileFlag}
                      updateTreeData={this.state.updateTreeData}
                    />
                  </div>
                </div>
                <div className="knowledge-right">
                  <Form
                    className="ant-advanced-search-form"
                    onSubmit={this.onSave}
                    {...formCol}
                  >
                    <Row>
                      <Col span={8}>
                        <Form.Item label="名称" colon={false}>
                          {getFieldDecorator('name', {
                            rules: [
                              { required: true, message: '名称不能为空' },
                            ],
                            initialValue: detail.name,
                          })(
                            <Input
                              type="text"
                              onChange={this.handleChangeName}
                              disabled={inputDisabled}
                              onBlur={() => {
                                const [moduleId, elementId] = [
                                  'mk0002',
                                  'ns-003',
                                ];
                                const eventData = {
                                  productionId,
                                  pageId,
                                  moduleId,
                                  elementId,
                                };
                                eventListener(eventData);
                              }}
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="上级" colon={false}>
                          {getFieldDecorator('upper', {
                            rules: [
                              { required: true, message: '上级不能为空' },
                            ],
                            initialValue: detail.upper || 0,
                          })(
                            <TreeSelect
                              style={{ width: '100%' }}
                              dropdownStyle={{
                                maxHeight: 400,
                                overflow: 'auto',
                              }}
                              treeData={upperDataList}
                              placeholder="Please select"
                              treeDefaultExpandAll
                              disabled={true}
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="排序" colon={false}>
                          {getFieldDecorator('sort', {
                            rules: [
                              { required: true, message: '排序不能为空' },
                            ],
                            initialValue: detail.orderNum || 0,
                          })(<Input type="text" disabled={inputDisabled} />)}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="仪器类型" colon={false}>
                          {getFieldDecorator('type', {
                            initialValue: 'DR',
                          })(
                            <Select disabled={true}>
                              <Option value="DR">DR</Option>
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      {!privateFlag && (
                        <Col span={8}>
                          <Form.Item label="中心" colon={false}>
                            {getFieldDecorator('center', {
                              initialValue: 'JF16373',
                            })(
                              <Select disabled={true}>
                                <Option value="JF16373">JF16373</Option>
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                      )}
                      <Col span={8}>
                        <Form.Item label="拼音简码" colon={false}>
                          {getFieldDecorator('pinyin', {
                            initialValue: detail.namepy,
                          })(<Input disabled={true} />)}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="五笔简码" colon={false}>
                          {getFieldDecorator('wubi', {
                            initialValue: detail.namewb,
                          })(<Input disabled={true} />)}
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item label="影像所见" {...formCol1}>
                      {getFieldDecorator('finding', {
                        initialValue: detail.finding,
                      })(
                        <TextArea
                          rows={8}
                          className="text"
                          disabled={areaDisabled}
                          onBlur={e => this.findingBlurEvent(e)}
                        ></TextArea>
                      )}
                    </Form.Item>
                    <Form.Item label="诊断建议" {...formCol1}>
                      {getFieldDecorator('impression', {
                        initialValue: detail.impression,
                      })(
                        <TextArea
                          rows={8}
                          disabled={areaDisabled}
                          className="text"
                          onBlur={e => this.impressionBlurEvent(e)}
                        ></TextArea>
                      )}
                    </Form.Item>
                    <div className="knowledge-btns">
                      <Button type="primary" htmlType="submit">
                        保存
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Delete
          visible={this.state.showDeleteModal}
          detail={this.state.detail}
          onCancel={this.hideDeleteModal}
        />
      </div>
    );
  }
}

export default withRouter(Form.create()(KnowledgeForm));
